import { Contact2, Phone, Search } from "lucide-react";
import { Button } from "../../../../../components/ui/button";
import { Card, CardContent } from "../../../../../components/ui/card";
import { Input } from "../../../../../components/ui/input";
import { Label } from "../../../../../components/ui/label";
import { CadastroSearchFormData } from "../types";
import { cleanCnpj, formatCnpj } from "../../../../../utils/format-utils";

interface SearchFormProps {
  searchForm: CadastroSearchFormData;
  onSearchFormChange: (form: CadastroSearchFormData) => void;
  onSearch: () => void;
  isSearching: boolean;
  fundName: string;
}

export function SearchForm({
  searchForm,
  onSearchFormChange,
  onSearch,
  isSearching,
  fundName,
}: SearchFormProps) {
  const formatPhone = (value: string) => {
    const numbersOnly = value.replace(/\D/g, "");

    if (numbersOnly.startsWith("55") && numbersOnly.length <= 13) {
      return numbersOnly
        .replace(/^(\d{2})(\d{2})(\d)/, "+$1 ($2) $3")
        .replace(/(\d{4})(\d)/, "$1-$2");
    } else if (numbersOnly.length <= 11) {
      const withCountryCode = "55" + numbersOnly;
      return withCountryCode
        .replace(/^(\d{2})(\d{2})(\d)/, "+$1 ($2) $3")
        .replace(/(\d{4})(\d)/, "$1-$2");
    }
    return value;
  };

  const formatCpfCnpj = (value: string) => {
    const clean = cleanCnpj(value);
    // Até 11 caracteres tratamos como CPF (numérico); acima, CNPJ alfanumérico.
    if (clean.length <= 11) {
      return clean
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d)/, ".$1-$2");
    }
    return formatCnpj(clean);
  };

  const handlePhoneChange = (value: string) => {
    const formatted = formatPhone(value);
    onSearchFormChange({ ...searchForm, telefone: formatted });
  };

  const handleCpfCnpjChange = (value: string) => {
    const formatted = formatCpfCnpj(value);
    onSearchFormChange({ ...searchForm, cpfCnpj: formatted });
  };

  return (
    <Card>
      <CardContent className="pt-6">
        <h2 className="text-xl font-bold text-foreground mb-4">
          Consultar Cadastro
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <Label htmlFor="telefone">Telefone</Label>
            <div className="relative">
              <Phone className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                id="telefone"
                placeholder="+55 (11) 99999-9999"
                value={searchForm.telefone}
                onChange={(e) => handlePhoneChange(e.target.value)}
                className="pl-9"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label htmlFor="cpfCnpj">CPF ou CNPJ</Label>
            <div className="relative">
              <Contact2 className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                id="cpfCnpj"
                placeholder="000.000.000-00 ou 00.000.000/0000-00"
                value={searchForm.cpfCnpj}
                onChange={(e) => handleCpfCnpjChange(e.target.value)}
                className="pl-9"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="invisible">Buscar</Label>
            <Button
              onClick={onSearch}
              disabled={isSearching || !fundName}
              className="w-full"
            >
              <Search className="h-4 w-4 mr-2" />
              {isSearching ? "Buscando..." : "Buscar Cadastro"}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
